import { render } from "./CaseDetail.vue?vue&type=template&id=45eb9894&scoped=true"
import script from "./CaseDetail.vue?vue&type=script&lang=js"
export * from "./CaseDetail.vue?vue&type=script&lang=js"

import "./CaseDetail.vue?vue&type=style&index=0&id=45eb9894&scoped=true&lang=scss"
import "./CaseDetail.vue?vue&type=style&index=1&id=45eb9894&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45eb9894"]])

export default __exports__